export const colors = {
  general: 'var(--color-primary)',
  primary: 'var(--color-secondary)',
  secondary: 'var(--color-accent)',
  green: 'var(--color-success)',
  neutral: 'var(--color-neutral)',
  white: '#FFFFFF',
  black: '#000000',
  gray: 'var(--color-gray)',
  texto: '#393e43',
  ligthGray: '#CDCDCD',
  disable: '#e9ecef',
  error: 'var(--color-danger)',
  warning: 'var(--color-warning)',
  bordes: '#e3e3e3',
  hoverSelect: '#0099b70f',
};
